<script setup lang="ts">
import {Icon} from '@iconify/vue'

import type {BellowsDirection} from '@/components/harmonika'

const direction = defineModel<BellowsDirection>('direction', {required: true})

function pullBellows(event?: Event) {
  event?.preventDefault()
  direction.value = 'ZUG'
}

function pushBellows(event?: Event) {
  event?.preventDefault()
  direction.value = 'DRUCK'
}
</script>

<template>
  <section class="flex w-full items-center justify-between rounded-xl border border-stone-700 bg-stone-800 p-3 shadow-xl md:p-4">
    <div class="flex items-center gap-4">
      <div class="hidden rounded-lg bg-stone-700 p-2 sm:block">
        <Icon icon="lucide:volume-2" class="text-2xl text-amber-500"/>
      </div>
      <div class="text-xs leading-tight text-stone-400">
        <div>Sound aktiv bei</div>
        <div>Tastendruck</div>
      </div>
    </div>

    <div class="flex flex-col items-center gap-1">
      <button
        type="button"
        class="min-w-[140px] rounded-lg border-b-4 px-6 py-2 text-lg font-bold text-white transition-all duration-100 active:translate-y-1 active:border-b-0 md:px-12 md:py-3"
        :class="direction === 'ZUG'
          ? 'border-blue-800 bg-blue-600 shadow-[0_0_20px_rgba(37,99,235,0.5)]'
          : 'border-emerald-800 bg-emerald-600'"
        @mousedown="pullBellows"
        @mouseup="pushBellows"
        @touchstart="pullBellows"
        @touchend="pushBellows"
      >
        {{ direction }}
      </button>
      <span class="text-[10px] tracking-wider text-stone-500 uppercase">
        Leertaste halten
      </span>
    </div>

    <div class="flex w-[60px] justify-end md:w-[100px]">
      <div
        class="flex h-10 w-2 flex-col justify-end overflow-hidden rounded-full bg-stone-700 transition-all duration-300 md:h-12 md:w-3"
        :class="direction === 'ZUG' ? 'scale-y-110' : 'scale-y-90'"
      >
        <div
          class="w-full transition-all duration-500"
          :class="direction === 'ZUG' ? 'h-full bg-blue-500' : 'h-1/2 bg-emerald-500'"
        />
      </div>
    </div>
  </section>
</template>
